
export const cookieJar = {
  /**
   * 
   * @param {string} name 
   * @returns {string | null}
   */
  get: name => {
    var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
    return v ? v[2] : null;
  },

  /**
   * 
   * @param {string} name 
   * @param {string} value 
   * @param {string} domain 
   * @param {Date} [expires]
   */
  set: (name, value, domain, expires) => {
    let cookieString = `${name}=${value};domain=${domain}`;
    if (expires) {
      cookieString += `;expires=${expires.toUTCString()}`;
    }
    document.cookie = cookieString;
  },

  /**
   * 
   * @param {string} name 
   * @param {string} domain 
   */
  remove: (name, domain) => {
    cookieJar.set(name, "", domain, new Date(0));
  }
};

const cookieToken = `__apex_test__`;
const getLastArrayItems = (arr, itemCount) => arr.slice(-itemCount);

/**
 * Retrieves the apex domain.
 * @param {Object} window The browser's window object for cookie manipulation.
 * @returns {string} The apex domain.
 */
export function getApexDomain(window) {
  if (!window.navigator.cookieEnabled) {
    throw new Error("Unable to detect apex domain without cookies enabled.");
  }

  let domain = "";

  const hostname = window.location.hostname;
  const hostParts = hostname.toLowerCase().split(".");

  for (let i = 1; i < hostParts.length + 1; i++) {
    domain = getLastArrayItems(hostParts, i).join(".");
    cookieJar.set(cookieToken, cookieToken, `.${domain}`);
    if (cookieJar.get(cookieToken)) {
      cookieJar.remove(cookieToken, `.${domain}`);
      return domain;
    }
  }

  // If we get to this point, it's likely the hostname is
  // "localhost", which is a reserved top-level domain name.
}

export const ga4 = {

  /**
   * Returns `_ga` cookie value in GA1.1 format.
   * @param {number} cid - Random number for user
   * @param {number} t - Timestamp that could match with session
   * @returns {string}
   * @see https://marketingliv.com/blogs/ga4-cookie-update-impact-2025
   */
  GA1 (cid, t) {
    return `_ga=GA1.1.${cid}.${t}`;
  },

  /**
   * Returns `_ga_*` cookie value in GS1.1 format.
   * @param {string} mid - Measurement ID
   * @param {number} sid - Session ID
   * @param {number} sn - Session number
   * @param {0 |  1} se - Session engaged
   * @param {number} lt - Last hit timestamp
   * @returns string
   * @see https://easyinsights.ai/blog/ga4-cookie-format-change-gs1-to-gs2/
   */
  GS1 (mid, sid, sn, se, lt) {
    return `_ga_${mid}=GS1.1.${sid}.${sn}.${se}.${lt}.0.0.0`;
  },

  /**
   * Returns `_ga_*` cookie value in GS2.1 format.
   * @param {string} mid - Measurement ID
   * @param {number} sid - Session ID
   * @param {number} sn - Session number
   * @param {0 |  1} se - Session engaged
   * @param {number} lt - Last hit timestamp
   * @returns string
   */
  GS2 (mid, sid, sn, se, lt) {
    return `_ga_${mid}=GS2.1.s${sid}$o${sn}$g${se}$t${this.ts(lt)}$j0$l0$h0`;
  },

  /**
   * Returns session last hit token for GS2 cookie.
   * @param {number} lt - Last hit timestamp
   * @returns {string}
   */
  ts (lt) {
    console.log("ts", String(lt).substring(0, 10));
    
    return String(lt).substring(0, 10);
  }
};
